import styled from 'styled-components';
import { tablet768, desktop1440 } from '@nubank/nuds-web/styles/breakpoints';

import ImageBlock from 'components/structure/ImageBlock';
import { paddingBuilder } from 'styles/themeUtils';

const CardImageBlock = styled(ImageBlock)`
  width: 100%;
  height: 84vw;
  ${paddingBuilder.all(0, 1.5)}

  ${tablet768`
    ${paddingBuilder.all(0)}
    height: 33vw;
  `}

  ${desktop1440`
    height: 37vw;
    max-height: 490px;
  `}
`;

CardImageBlock.displayName = 'CardImageBlock';

export default CardImageBlock;
